import { AppComponent } from './../app.component';
import { FooterComponent } from './../footer/footer.component';
import { Component, OnInit, OnDestroy, HostListener, AfterViewInit, Input, ElementRef } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import 'hammerjs';
import * as $ from 'jquery';
import * as slick from 'ngx-slick';
import { ActivatedRoute, Router } from '@angular/router';
import { Http } from '@angular/http';
import { element } from 'protractor';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {

  mission: any;
  about: any;
  brands: any;
  tobias: any;
  team: any;
  carousel: any;
  investors: any;
  information: any;
  contact: any;
  preslist: any;
  conclusion: any;
  missionDistance: any;
  aboutDistance: any;
  brandsDistance: any;
  tobiasDistance: any;
  teamDistance: any;
  carouselDistance: any;
  investorsDistance: any;
  preslistDistance: any;
  informationDistance: any;
  contactDistance: any;
  conclusionDistance: any;
  distanceLead: any;
  private fragment: string;
  menuClosed: boolean;
  stockUp: boolean;
  didSlide: boolean;
  invLeftSlide: boolean;
  invRightSlide: boolean;
  privacyOpen: boolean;

  // --> ON SCROLL LOGIC
  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const $window = $(window);

    if (window.location.href.indexOf('about') !== -1 || window.location.href.indexOf('brands') !== -1 ||
    window.location.href.indexOf('team') !== -1 || window.location.href.indexOf('article') !== -1) {
      this.mission = document.getElementById('mission');
      this.missionDistance = this.mission.offsetTop - 80;
    } else if (window.location.href.indexOf('investors') !== -1) {
      this.mission = document.getElementById('mission');
      this.missionDistance = this.mission.offsetTop - 80;
      // this.preslist = document.getElementById('pres-list');
      // this.preslistDistance = this.preslist.offsetTop - 80;
    } else  {
      this.mission = document.getElementById('mission');
      this.missionDistance = this.mission.offsetTop - 80;
      this.about = document.getElementById('about');
      this.aboutDistance = this.about.offsetTop - 80;
      this.brands = document.getElementById('brands');
      this.brandsDistance = this.brands.offsetTop - 80;
      this.tobias = document.getElementById('tobias');
      this.tobiasDistance = this.tobias.offsetTop - 80;
      this.team = document.getElementById('team');
      this.teamDistance = this.team.offsetTop - 80;
      this.investors = document.getElementById('investors');
      this.investorsDistance = this.investors.offsetTop - 80;
      this.contact = document.getElementById('contact');
      this.contactDistance = this.contact.offsetTop - 80;
    }
    this.distanceLead = 250;

    // --> CHANGE NAV COLORS ON SCROLL <-- //
    const header = document.getElementById('nav-bar');
    if ($window.scrollTop() >= this.missionDistance) {
      header.classList.add('white');
      $('.nav-link').css('color', '#6d6b6b');
    } else {
      if (window.innerWidth <= 1194 && this.menuClosed === false) {

      } else {
        header.classList.remove('white');
      }
      if (window.location.href.indexOf('about') !== -1 || window.location.href.indexOf('brands') !== -1 ||
          window.location.href.indexOf('team') !== -1 || window.location.href.indexOf('investors') !== -1 ||
          window.location.href.indexOf('article') !== -1) {

      } else {
        $('.nav-link').css('color', '#fff');
      }
    }

    // --> CHECK FOR CONTACT ON SCROLL < --//
    if ($window.scrollTop() > this.contactDistance) {
      if (window.innerWidth <= 1194) {
        if (window.location.href.indexOf('about') !== -1 || window.location.href.indexOf('brands') !== -1 ||
          window.location.href.indexOf('team') !== -1 || window.location.href.indexOf('investors') !== -1 ||
          window.location.href.indexOf('article') !== -1) {
        } else {
          const mobileAbout = document.getElementById('mobile-about');
          mobileAbout.classList.remove('opac');
          const mobileBrands = document.getElementById('mobile-brands');
          mobileBrands.classList.remove('opac');
          const mobileTeam = document.getElementById('mobile-team');
          mobileTeam.classList.remove('opac');
          const mobileInvestors = document.getElementById('mobile-investors');
          mobileInvestors.classList.remove('opac');
          const mobileContact = document.getElementById('mobile-contact');
          mobileContact.classList.add('opac');
        }
      }
    }

    if ($window.scrollTop() > this.contactDistance) {
      if (window.innerWidth >= 1195) {
        if (window.location.href.indexOf('about') !== -1 || window.location.href.indexOf('brands') !== -1 ||
          window.location.href.indexOf('team') !== -1 || window.location.href.indexOf('investors') !== -1 ||
          window.location.href.indexOf('article') !== -1) {
        } else {
          if (!this.didSlide) {
            $('#under-bar').css({'opacity': 1});
            $('#under-bar').animate({'margin-left': '469px'});
            this.didSlide = true;
          }
        }
      }
    } else {
      // if (this.didSlide === true) {
      //   $('#under-bar').css({'opacity': 0});
      //   this.didSlide = false;
      // }
    }

    // --> FADE NAV ON SCROLL <-- //
    if ($window.scrollTop() > 0 && $window.scrollTop() < this.missionDistance) {
      const el = document.querySelector('#privacy');
      const test = getComputedStyle(el);
      if (test.display.toString() === 'none') {
        if (this.menuClosed !== false) {
          $('#nav-bar').fadeOut('fast');
        }
      }
    } else {
      if (this.menuClosed !== false) {
        const el = document.querySelector('#privacy');
        const test = getComputedStyle(el);
        if (test.display.toString() === 'none') {
          $('#nav-bar').fadeIn('fast');
        }
      }
    }

    // --> FADE IN TEXTS ON SCROLL <-- //
    if (window.location.href.indexOf('about') !== -1) {
      if ($window.scrollTop() > this.missionDistance - this.distanceLead) {
        $('#mission-subtitle').animate({opacity: 1}, {duration: 'slow'});
      }
    } else if (window.location.pathname === '/brands') {

    } else if (window.location.pathname === '/team') {

    } else if (window.location.href.indexOf('investors') !== -1) {
      const body = document.body;
      const html = document.documentElement;
      const height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
      const footerHeight = height - window.innerHeight;
      if ($window.scrollTop() < this.mission.offsetTop - 200) {
        $('#vertical-container').fadeOut('fast');
      } else if ($window.scrollTop() > footerHeight - 350) {
        $('#vertical-container').fadeOut('fast');
      } else {
        $('#vertical-container').fadeIn('fast');
      }
      if ($window.scrollTop() > this.missionDistance - this.distanceLead - 100) {
        if (window.innerWidth >= 720) {
          $('#left-container').animate({width: '100%'}, {duration: 500});
        } else {
          $('#left-container').animate({width: '100%'}, {duration: 500});
        }
      }
      if ($window.scrollTop() > this.missionDistance - this.distanceLead + 350) {
        if (window.innerWidth >= 720) {
            $('#right-container').animate({width: '100%'}, {duration: 500});
        } else {
            $('#right-container').animate({width: '100%'}, {duration: 500});
        }
      }
    } else  {
      if ($window.scrollTop() > this.missionDistance - this.distanceLead) {
        $('#mission-text').animate({opacity: 1}, {duration: 'slow'});
        $('#mission-subtitle').animate({opacity: 1}, {duration: 'slow'});
        $('#mission-underline').animate({opacity: 1}, {duration: 'slow'});
      }
      if ($window.scrollTop() > this.brandsDistance - this.distanceLead) {
        $('#brands-text').animate({opacity: 1}, {duration: 'slow'});
        $('#brands-subtitle').animate({opacity: 1}, {duration: 'slow'});
        $('#brands-underline').animate({opacity: 1}, {duration: 'slow'});
      }
      if ($window.scrollTop() > this.teamDistance - this.distanceLead) {
        $('#team-title').animate({opacity: 1}, {duration: 'slow'});
        $('#team-subtitle-upper').animate({opacity: 1}, {duration: 'slow'});
        $('#team-subtitle-lower').animate({opacity: 1}, {duration: 'slow'});
        $('#team-underline').animate({opacity: 1}, {duration: 'slow'});
      }
      if ($window.scrollTop() > this.investorsDistance - this.distanceLead) {
        $('#investors-title').animate({opacity: 1}, {duration: 'slow'});
        $('#investors-subtitle-upper').animate({opacity: 1}, {duration: 'slow'});
        $('#investors-subtitle-lower').animate({opacity: 1}, {duration: 'slow'});
        $('#investors-underline').animate({opacity: 1}, {duration: 'slow'});
      }
      if ($window.scrollTop() > this.contactDistance - this.distanceLead) {
        $('#contact-title').animate({opacity: 1}, {duration: 'slow'});
        $('#contact-subtitle-upper').animate({opacity: 1}, {duration: 'slow'});
        $('#cs-upper').animate({opacity: 1}, {duration: 'slow'});
        $('#contact-subtitle-lower').animate({opacity: 1}, {duration: 'slow'});
        $('#contact-underline').animate({opacity: 1}, {duration: 'slow'});
      }
      // --> SLIDE IN PANELS ON SCROLL <-- //
      if ($window.scrollTop() > this.missionDistance + this.distanceLead - 150) {
        $('#left-container').animate({width: '100%'}, {duration: 500});
      }
      if ($window.scrollTop() > this.aboutDistance - this.distanceLead + 150) {
        // $('#right-container').animate({right: '0'}, {duration: 1200, easing: 'swing'});
        $('#right-container').animate({width: '100%'}, {duration: 500});
      }
      if (window.innerWidth >= 720) {
        if ($window.scrollTop() > this.tobiasDistance - this.distanceLead * 2) {
          // $('#tobias-left-container').animate({left: '0'}, {duration: 'slow', easing: 'swing'});
          $('#tobias-left-container').animate({width: '100%'}, {duration: 500});
        }
      }
    }

    // --> CHANGE HAMBURGER MENU COLOUR ON SCROLL <-- //
    const navMenuTop = document.getElementById('nav-icon-top');
    const navMenuMiddle = document.getElementById('nav-icon-middle');
    const navMenuBottom = document.getElementById('nav-icon-bottom');
    if ($window.scrollTop() > 0) {
      navMenuTop.classList.add('grey');
      navMenuMiddle.classList.add('grey');
      navMenuBottom.classList.add('grey');
    } else {
      navMenuTop.classList.remove('grey');
      navMenuMiddle.classList.remove('grey');
      navMenuBottom.classList.remove('grey');
    }
  }

  // --> HEADER RESIZE LOGIC <-- //
  @HostListener('window:resize', ['$event'])
  onResize() {
    const $window = $(window);
    const header = document.getElementById('nav-bar');
    if ($window.scrollTop() <= this.missionDistance && this.menuClosed) {
      header.classList.remove('white');
    }
    if (window.innerWidth >= 1195 && !this.menuClosed) {
      $('#menu-btn').prop('checked', false);
      this.menuClosed = true;
    }
    if (window.innerWidth >= 1195) {
      const mobileAbout = document.getElementById('mobile-about');
      mobileAbout.classList.remove('opac');
      const mobileBrands = document.getElementById('mobile-brands');
      mobileBrands.classList.remove('opac');
      const mobileTeam = document.getElementById('mobile-team');
      mobileTeam.classList.remove('opac');
      const mobileInvestors = document.getElementById('mobile-investors');
      mobileInvestors.classList.remove('opac');
      const mobileContact = document.getElementById('mobile-contact');
      mobileContact.classList.remove('opac');
    }
  }

  constructor(public angulartics2: Angulartics2,
              private route: ActivatedRoute,
              private router: Router,
              private http: Http) {

  }

  ngOnInit() {
    this.menuClosed = true;
    this.invLeftSlide = false;
    this.invRightSlide = false;
    this.stockUp = true;
    this.privacyOpen = true;

    //-->  WORLD TRADING DATA
    // return this.http.get('https://api.worldtradingdata.com/api/v1/stock?symbol=MIMI&api_token=wXJFbGni5PVbCpTW20HeEjK1FDkrMqT8qhlGwNuX8wFzihCFtXFrkG9noPm8').toPromise().then((response) => {
    // console.log(response);
    // if (response.json().data) {
    //     $('#header-stock-price').html('$' + response.json().data[0].price);
    //     if (response.json().data[0].change_pct >= 0) {
    //       this.stockUp = true;
    //     } else {
    //       this.stockUp = false;
    //     }
    //     $('#header-stock-change').html('(' + response.json().data[0].change_pct + '%)');
    //   }
    // });
  }

  ngAfterViewInit(): void {
    if (this.route.snapshot.url[0]) {
      $('#under-bar').css({'opacity': 1});
      if (window.innerWidth >= 1195) {
      } else {
      }
    }
    if (window.innerWidth <= 1194) {
      if (window.location.href.indexOf('about') !== -1) {
        const mobileAbout = document.getElementById('mobile-about');
        mobileAbout.classList.add('opac');
        const mobileBrands = document.getElementById('mobile-brands');
        mobileBrands.classList.remove('opac');
        const mobileTeam = document.getElementById('mobile-team');
        mobileTeam.classList.remove('opac');
        const mobileInvestors = document.getElementById('mobile-investors');
        mobileInvestors.classList.remove('opac');
        const mobileContact = document.getElementById('mobile-contact');
        mobileContact.classList.remove('opac');
      } else if (window.location.href.indexOf('brands') !== -1) {
        const mobileAbout = document.getElementById('mobile-about');
        mobileAbout.classList.remove('opac');
        const mobileBrands = document.getElementById('mobile-brands');
        mobileBrands.classList.add('opac');
        const mobileTeam = document.getElementById('mobile-team');
        mobileTeam.classList.remove('opac');
        const mobileInvestors = document.getElementById('mobile-investors');
        mobileInvestors.classList.remove('opac');
        const mobileContact = document.getElementById('mobile-contact');
        mobileContact.classList.remove('opac');
      } else if (window.location.href.indexOf('team') !== -1) {
        const mobileAbout = document.getElementById('mobile-about');
        mobileAbout.classList.remove('opac');
        const mobileBrands = document.getElementById('mobile-brands');
        mobileBrands.classList.remove('opac');
        const mobileTeam = document.getElementById('mobile-team');
        mobileTeam.classList.add('opac');
        const mobileInvestors = document.getElementById('mobile-investors');
        mobileInvestors.classList.remove('opac');
        const mobileContact = document.getElementById('mobile-contact');
        mobileContact.classList.remove('opac');
      } else if (window.location.href.indexOf('investors') !== -1) {
        const mobileAbout = document.getElementById('mobile-about');
        mobileAbout.classList.remove('opac');
        const mobileBrands = document.getElementById('mobile-brands');
        mobileBrands.classList.remove('opac');
        const mobileTeam = document.getElementById('mobile-team');
        mobileTeam.classList.remove('opac');
        const mobileInvestors = document.getElementById('mobile-investors');
        mobileInvestors.classList.add('opac');
        const mobileContact = document.getElementById('mobile-contact');
        mobileContact.classList.remove('opac');
      } else {
        const mobileAbout = document.getElementById('mobile-about');
        mobileAbout.classList.remove('opac');
        const mobileBrands = document.getElementById('mobile-brands');
        mobileBrands.classList.remove('opac');
        const mobileTeam = document.getElementById('mobile-team');
        mobileTeam.classList.remove('opac');
        const mobileInvestors = document.getElementById('mobile-investors');
        mobileInvestors.classList.remove('opac');
        const mobileContact = document.getElementById('mobile-contact');
        mobileContact.classList.remove('opac');
      }
    } else {
      if (window.location.href.indexOf('about') !== -1) {
        $('#under-bar').css({'opacity': 1});
        $('#under-bar').animate({'margin-left': '36px'});
      } else if (window.location.href.indexOf('brands') !== -1) {
        $('#under-bar').css({'opacity': 1});
        $('#under-bar').animate({'margin-left': '138px'});
      } else if (window.location.href.indexOf('team') !== -1) {
        $('#under-bar').css({'opacity': 1});
        $('#under-bar').animate({'margin-left': '235px'});
      } else if (window.location.href.indexOf('investors') !== -1) {
        $('#under-bar').css({'opacity': 1});
        $('#under-bar').animate({'margin-left': '343px'});
      } else {
        $('#under-bar').css({'opacity': 0});
      }
    }
  }

  ngOnDestroy() {

  }

  toHome() {
    $('html,body').scrollTop(0);
    $('#under-bar').css({'opacity': 0});
    if (window.innerWidth <= 1194) {
      const mobileAbout = document.getElementById('mobile-about');
      mobileAbout.classList.remove('opac');
      const mobileBrands = document.getElementById('mobile-brands');
      mobileBrands.classList.remove('opac');
      const mobileTeam = document.getElementById('mobile-team');
      mobileTeam.classList.remove('opac');
      const mobileInvestors = document.getElementById('mobile-investors');
      mobileInvestors.classList.remove('opac');
      const mobileContact = document.getElementById('mobile-contact');
      mobileContact.classList.remove('opac');
      if (!this.menuClosed) {
        $('#menu-btn').prop('checked', false);
        this.menuClosed = true;
        const header = document.getElementById('nav-bar');
        header.classList.remove('white');
      }
    }
  }

  toAbout() {
    $('html,body').scrollTop(0);
    $('#under-bar').css({'opacity': 1});
    $('#under-bar').animate({'margin-left': '36px'});
    $('#menu-btn').prop('checked', false);
    if (window.innerWidth <= 1194) {
      const mobileAbout = document.getElementById('mobile-about');
      mobileAbout.classList.add('opac');
      const mobileBrands = document.getElementById('mobile-brands');
      mobileBrands.classList.remove('opac');
      const mobileTeam = document.getElementById('mobile-team');
      mobileTeam.classList.remove('opac');
      const mobileInvestors = document.getElementById('mobile-investors');
      mobileInvestors.classList.remove('opac');
      const mobileContact = document.getElementById('mobile-contact');
      mobileContact.classList.remove('opac');
    }
    this.toggleMenu();
  }

  toBrands() {
    $('html,body').scrollTop(0);
    $('#under-bar').css({'opacity': 1});
    $('#under-bar').animate({'margin-left': '138px'});
    $('#menu-btn').prop('checked', false);
    if (window.innerWidth <= 1194) {
      const mobileAbout = document.getElementById('mobile-about');
      mobileAbout.classList.remove('opac');
      const mobileBrands = document.getElementById('mobile-brands');
      mobileBrands.classList.add('opac');
      const mobileTeam = document.getElementById('mobile-team');
      mobileTeam.classList.remove('opac');
      const mobileInvestors = document.getElementById('mobile-investors');
      mobileInvestors.classList.remove('opac');
      const mobileContact = document.getElementById('mobile-contact');
      mobileContact.classList.remove('opac');
    }
    this.toggleMenu();
  }

  toTeam() {
    $('html,body').scrollTop(0);
    $('#under-bar').css({'opacity': 1});
    $('#under-bar').animate({'margin-left': '235px'});
    $('#menu-btn').prop('checked', false);
    if (window.innerWidth <= 1194) {
      const mobileAbout = document.getElementById('mobile-about');
      mobileAbout.classList.remove('opac');
      const mobileBrands = document.getElementById('mobile-brands');
      mobileBrands.classList.remove('opac');
      const mobileTeam = document.getElementById('mobile-team');
      mobileTeam.classList.add('opac');
      const mobileInvestors = document.getElementById('mobile-investors');
      mobileInvestors.classList.remove('opac');
      const mobileContact = document.getElementById('mobile-contact');
      mobileContact.classList.remove('opac');
    }
    this.toggleMenu();
  }

  toInvestors() {
    $('html,body').scrollTop(0);
    $('#under-bar').css({'opacity': 1});
    $('#under-bar').animate({'margin-left': '343px'});
    $('#menu-btn').prop('checked', false);
    if (window.innerWidth <= 1194) {
      const mobileAbout = document.getElementById('mobile-about');
      mobileAbout.classList.remove('opac');
      const mobileBrands = document.getElementById('mobile-brands');
      mobileBrands.classList.remove('opac');
      const mobileTeam = document.getElementById('mobile-team');
      mobileTeam.classList.remove('opac');
      const mobileInvestors = document.getElementById('mobile-investors');
      mobileInvestors.classList.add('opac');
      const mobileContact = document.getElementById('mobile-contact');
      mobileContact.classList.remove('opac');
    }
    this.toggleMenu();
  }

  toContact() {
    try {
      setTimeout(() => {
        $('html, body').animate({scrollTop: $('#contact').offset().top}, {duration: 'fast', complete: function() {
          if (this.angulartics2) {
            this.angulartics2.eventTrack.next({
              action: 'section-view-contact'
            });
            console.log(this.angulartics2);
          }
        }});
      }, 500);
      if (window.innerWidth >= 1195) {
        $('#under-bar').css({'opacity': 1});
        $('#under-bar').animate({'margin-left': '469px'});
      } else {
        const mobileAbout = document.getElementById('mobile-about');
        mobileAbout.classList.remove('opac');
        const mobileBrands = document.getElementById('mobile-brands');
        mobileBrands.classList.remove('opac');
        const mobileTeam = document.getElementById('mobile-team');
        mobileTeam.classList.remove('opac');
        const mobileInvestors = document.getElementById('mobile-investors');
        mobileInvestors.classList.remove('opac');
        const mobileContact = document.getElementById('mobile-contact');
        mobileContact.classList.add('opac');
        $('#menu-btn').prop('checked', false);
        this.menuClosed = true;
      }
      if (this.menuClosed === false) {
        this.toggleMenu();
      }
    } catch (e) {

    }
  }

  toggleMenu() {
    if (window.innerWidth <= 1194) {
      this.menuClosed = !this.menuClosed;
      const header = document.getElementById('nav-bar');
      if (!this.menuClosed) {
        header.classList.add('white');
      } else {
        const $window = $(window);
        if ($window.scrollTop() <= this.missionDistance) {
          header.classList.remove('white');
        }
      }
    }
    if (window.location.href.indexOf('brands') !== -1 && !this.menuClosed) {
      $('.next').css('opacity', 0);
    } else {
      $('.next').css('opacity', 1);
    }
  }

  closePrivacy() {
    try {
      $('.nav-item').removeClass('hide-item');
      $('#privacy').removeClass('show-item');
      $('.header').removeClass('is-white');
      $('.button-container').addClass('hide-item');
      // $('.desktop-page-container').css('height', 'auto');
      // $('.desktop-page-container').css('overflow', 'auto');
      $('html, body').scrollTop(0);
    } catch (e) {
      console.log(e);
    }
  }

}
